// Route module for Vuex store
// Replaces vuex-router-sync functionality for Vue 3

const state = () => ({
  fullPath: '/',
  hash: '',
  matched: [],
  meta: {},
  name: null,
  params: {},
  path: '/',
  query: {},
})

const mutations = {
  'route/UPDATE_ROUTE'(state, route) {
    state.fullPath = route.fullPath
    state.hash = route.hash
    state.matched = route.matched
    state.meta = route.meta
    state.name = route.name
    state.params = { ...route.params }
    state.path = route.path
    state.query = { ...route.query }
  },
}

const getters = {
  // Legacy getters for backward compatibility
  params: state => state.params,
  query: state => state.query,
  organizationId: state => state.params.organizationId,

  // Base route getter used in Sidebar
  baseRoute: state => {
    if (state.params.organizationId) {
      return `/organizations/${state.params.organizationId}`
    }
    return '/'
  },
}

export default {
  namespaced: false, // Keep non-namespaced for backward compatibility
  state,
  mutations,
  getters,
}
